export function locationToString(location: any){
    return location.name
}